import React from "react";
import { Link } from "react-router-dom";
import { Anchor, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CtaBand = () => (
  <section className="relative bg-navy-900 py-20 sm:py-28 overflow-hidden" data-testid="cta-band">
    <div
      className="absolute inset-0 opacity-20 bg-cover bg-center"
      style={{
        backgroundImage:
          "url(https://images.unsplash.com/photo-1631655104117-f1cfdf688772?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
      }}
    />
    <div className="absolute inset-0 bg-navy-900/70" />
    <div className="relative max-w-4xl mx-auto px-6 text-center">
      <Reveal>
        <p className="eyebrow text-gold-400 mb-5">Your Vessel. Our Vigilance.</p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight">
          Peace of mind begins with a single dockside visit.
        </h2>
        <p className="mt-6 text-slate-300 max-w-2xl mx-auto">
          Tell us about your vessel and marina. We'll follow up to confirm scope,
          scheduling, and the oversight plan that fits how you use your boat.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/request-inspection"
            className="inline-flex items-center justify-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-semibold px-8 py-4 rounded-full transition-all hover:shadow-[0_12px_32px_-10px_rgba(212,175,55,0.7)]"
            data-testid="ctaband-request-button"
          >
            <Anchor className="h-5 w-5" /> Request an Inspection
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center gap-2 border border-white/25 text-white hover:border-gold-500/60 hover:text-gold-400 font-semibold px-8 py-4 rounded-full transition-colors"
            data-testid="ctaband-pricing-button"
          >
            View Plans <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
